import { render, staticRenderFns } from "./myDivideInto.vue?vue&type=template&id=00cf8d0d"
import script from "./myDivideInto.vue?vue&type=script&lang=js"
export * from "./myDivideInto.vue?vue&type=script&lang=js"
import style0 from "./myDivideInto.vue?vue&type=style&index=0&id=00cf8d0d&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports